<template>
  <div class="jiejuefangan home baozhang fwbz">
    <div id="nav" class="header">
      <head-top></head-top>
      <div class="default-title">
        <div class="default-title-top">完善的管理制度保证服务品质</div>
        <div class="default-title-bottom">运营人员全程监管，所有订单人工审核</div>
      </div>
    </div>

    <div class="fangan-main">
      <div class="fangan-advantage">
        <div class="fangan-advantage-list">
          <div class="fangan-advantage-content" v-for="(item, index) in advantageList" :key="index">
            <div class="fangan-advantage-info" :class="{right:(index+1)%2==0}">
              <div class="fangan-advantage-top">
                0{{index+1}}
                <div class="fangan-advantage-top-title">{{item.title}}</div>
              </div>
              <div
                class="fangan-advantage-bottom-info">{{item.info}}</div>
            </div>
            <div class="fangan-advantage-img">
              <img :src="item.img" alt />
            </div>
          </div>
        </div>
      </div>

      <div class="home-join">
        <div class="home-service-tit">加入聚师傅平台，共同打造行业服务新规范</div>
        <div class="home-join-cont">
          <ul>
            <li class="home-join-item" v-for="(item, index) in joinArr" :key="index" @click="goPage(item)">
              <div class="home-join-item-main"></div>
              <svg aria-hidden="true">
                <use class="icon" :xlink:href="'#'+item.icon" />
              </svg>
              <span>{{item.text}}</span>
              <i class="iconfont joinJt iconjiantou_big"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
export default {
  components: {
    headTop
  },
  data() {
    return {
      advantageList: [
        {
          title: "全程资金托管  保证双方利益",
          img: require("../../assets/img/fuwubaoz_1.png"),
          info:
            "用户下单后的预付款将由聚师傅平台作为担保平台代为托管，待到师傅安装完成且用户确认满意后才放款。过程中有任何问题都由平台客服人员跟进解决"
        },
        {
          title: "安装师傅全部实名认证",
          img: require("../../assets/img/fuwubaoz_2.png"),
          info:
            "为保证团队品质保护消费者财产安全，猫大师对每一位安装师傅进行实名认证以及备案。平台会即时发送为您服务的师傅信息，便于复核确认"
        },
        {
          title: "消费者确认满意后支付费用",
          img: require("../../assets/img/fuwubaoz_3.png"),
          info:
            "消费者通过猫大师微信服务号确认完成订单后师傅款项才会支付给师傅，对师傅打分也会直接影响师傅的收入"
        },
        {
          title: "服务质量严格监管",
          img: require("../../assets/img/fuwubaoz_4.png"),
          info:
            "聚师傅管理人员会对师傅完成的订单逐个进行确认，对于问题订单全程跟进解决，保证做到妥善解决消费者问题"
        },
        {
          title: "末位淘汰制保证团队品质",
          img: require("../../assets/img/fuwubaoz_5.png"),
          info:
            "聚师傅聘请专业讲师为所有师傅讲授技能，并对学习结果进行考核监督，对于考核不合格的师傅严格实行末位淘汰制度，保证服务团队精良"
        }
      ],
      joinArr: [
        {
          icon: "iconicon_home_hongyingchang1",
          text: "加入服务商团队"
        },
        {
          icon: "iconicon_home_shifu1",
          text: "加入师傅团队"
        }
      ]
    };
  },
  mounted() {
    var _this = this;
  },
  methods: {
    bannerCheck(item, index) {
      this.bannerIndex = index;
      for (let i of this.bannerTab) {
        i.isSelected = false;
      }
      item.isSelected = true;
    },
    goPage(item){
      if(item.text=="加入服务商团队"){
        this.$router.push({ path: "/service_ruzhu" });
      }
      if(item.text=="加入师傅团队"){
        this.$router.push({ path: "/ruzhu" });
      }
    }
  }
};
</script>
<style lang="scss">
.fwbz{
    #nav {
    .head-rightBottom {
      .baozhang {
        border-bottom: 2px solid #fff;
      }
    }
    }
}
.baozhang {
  #nav {
    background: url("../../assets/img/fuwubaozhang_banner.jpg") no-repeat;
    background-position: center;
    background-size: cover;
    height: 400px;
    overflow: hidden;
    .default-title {
      width: 594px;
      height: 167px;
      margin: 0 auto;
      padding: 30px 0;
      margin-top: 160px;
      .default-title-top {
        height: 40px;
        font-size: 30px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 40px;
        position: relative;
        text-align: center;
      }
      .default-title-top::after {
        content: "";
        position: absolute;
        width: 215px;
        height: 1px;
        background: #ffffff;
        top: 54px;
        left: 32.1%;
      }
      .default-title-bottom {
        text-align: center;
        height: 21px;
        font-size: 16px;
        color: rgba(255, 255, 255, 1);
        line-height: 21px;
        margin-top: 47px;
      }
    }
  }
  .fangan-advantage-bottom-info {
    width: 455px;
    font-size: 12px;
    color: rgba(94, 96, 102, 1);
    line-height: 20px;
    margin-left: 111px;
  }
  .fangan-main{
      margin-top: 0;
  }
}
</style>